<h2>Vertrag anlegen</h2>
<mat-form-field appearance="fill">
  <mat-label>Name</mat-label>
  <input [formControl]="name" matInput #first>
</mat-form-field>
